import ApplicationAdapter from "./application";

export default class RemoteHandsRequestAdapter extends ApplicationAdapter {
  urlForCreateRecord() {
    return `${this.apiBaseUri}/remotehands/create`;
  }

  urlForUpdateRecord(id) {
    return `${this.apiBaseUri}/remotehands/cancel?key=${id}`;
  }
}
